import React, { Component } from 'react'
import { connect } from 'react-redux'
import { browserHistory } from 'react-router'
import DocumentTitle from "react-document-title"

import {  ButtonGroup, Tabs, Tab, Checkbox } from 'react-bootstrap'

import { fetchTrips, createTrip, updateTrip, removeTrip } from '../../ducks/trips'
import { docListStyle } from '../../containers/PageStyles'
import { getTabLabel } from '../TripStatus' 
import Button from '../../components/Button.jsx'

import { replaceQuery } from '../../lib/AppTools.js'

import TripsSelectorButton from '../TripsSelector.jsx'
import TripsReportButton from '../TripsReport.jsx'

import isObjectEqual from '../../../lib/isObjectEqual.js'
import * as selectors from '../../selectors'
import PlanTriggerModal from '../../trips/PlanTriggerModal.jsx'
import { getText, getTextWithTokens, getLanguage } from '../../lib/text.js'

import ModalTagsEditor from '../../tags/ModalTagsEditor'
import TripsTable from './TripsPageTable'
import TripsTable2 from './TripsPageTable2'
import TagsFilter from "../../tags/TagsFilter"
import { getTripTags } from '../../selectors/index';

const tabsWithCount = new Set([
  "nuevos", "propuesta", "negociando", "contrato", "aprobados", "otros"
])

/**
 * QueryString managing functions
 * #TODO #SIN: TripsPage gets Query from props, but updates it through these functions
 * #TODO these should be standard
 */

const getQuery = () => browserHistory.getCurrentLocation().query

const goto = changes => replaceQuery(browserHistory, { ...getQuery(), ...changes })

const editTrip = id => browserHistory.push(`/private/trip/${id}`)

const setTab                = tab => goto({ tab })
const onFilterTag           = tag => goto({ tag })
const setClientPicker       = modal => goto({ modal })
const setClientPickerSearch = clientSearch => goto({ clientSearch })
const setViewMode           = view => goto({ view }) // table, list

/** Auxiliary components **/

const FilterMineCheckbox = ({ query, style }) => (
  <Checkbox 
    style={{ marginLeft: 25, display: "inline", ...style }} 
    value={query.mine}
    onChange={evt => goto({ mine: evt.target.checked ? "on" : "off" })}
  >
    {getText("Sólo lo mío")}
  </Checkbox>
)


/**
 * 
 */
type OperPageProps = {
  trips: Object, 
  createTrip: Function => void, 
  update: () => void, 
  updateStatus: (string, Object) => void, 
  updateComment: (string, string) => void, 
  updateTags: (string, Object) => void, 
  remove: (string) => void,
  query: Object, 
  getTripPendingTasks: string => Object[],
  ready: boolean
}

class TripsPage extends React.PureComponent 
{
  constructor(props) {
    super(props)
    this.state = { 
      editingTrip: null, 
      deleting: false, 
      modal: null, 
    } 
  }
  
  props: OperPageProps; 

  create() { 
    this.props.createTrip(this.props.username, id => browserHistory.push(`/private/trip/${id}`)) 
  }

  remove(id) {
    if (confirm(getTextWithTokens(`delete_trip`, [this.props.trips[id].name || ""]))) {
      this.props.remove(id)
    }
  }
  
  handleSort(sortColumn) {
    if (sortColumn === this.props.query.sortColumn) {
      replaceQuery(browserHistory, this.props.query, { 
        sortDirection: this.props.query.sortDirection === "ASC" ? "DESC" : "ASC" 
      })
    }
    else {
      replaceQuery(browserHistory, this.props.query, { 
        sortColumn, 
        sortDirection: (sortColumn === "creation" || sortColumn === "modification" ? "DESC" : "ASC")
      })
    }
  }

  render() {
    if (!this.props.ready) return <span>Loading</span>

    const buttonStyle = { marginTop: 5, marginBottom: 5, marginRight: 5, marginLeft: 5 }

    const Table = (
      (this.props.query.view == "table" && TripsTable)
      || (this.props.query.view == "table2" && TripsTable2)
    )
    
    return (
      <div
        style={docListStyle()}
        className={this.state.deleting ? "deleting" : "normal"}
      >
        <DocumentTitle title={`${getLanguage() == "ch" ? getText("Ventas") : getText("Ventas")}: ${getTabLabel(this.props.query.tab)}`} />
        <div style={{marginBottom: 5, paddingBottom: 5, borderBottomWidth: 1, borderBottomColor: "#ccc", borderBottomStyle: "solid"}}>
          <h2 style={{display:"inline-block", marginTop: 0, marginBottom: 5}}>{getText("Ventas")}</h2>
          <div style={{marginLeft: 40, float: "right", display: "inline", marginTop: 0}}>
            <ButtonGroup style={{marginLeft: 10}}>
              <Button active={this.props.query.view == "table"}  onClick={() => setViewMode("table")} >Vista 1</Button>
              <Button active={this.props.query.view == "table2"} onClick={() => setViewMode("table2")}>Vista 2</Button>
            </ButtonGroup>
            <TagsFilter 
              selectedTag={this.props.query.tag} 
              style={{ marginLeft: 25 }} 
              data={this.props.tags} 
              onChange={tag => onFilterTag(tag)}
            />
            <Button 
              glyph="tag"
              style={buttonStyle}
              onClick={() => this.setState({modal: "tags"})}
            >
              {getText("Etiquetas")}
            </Button>

            <FilterMineCheckbox 
              query={this.props.query}
              style={{display: "inline", marginLeft: 15, marginRight: 25}} 
            />

            <TripsSelectorButton 
              trips={this.props.trips} 
              setClientPicker={modal => setClientPicker(modal)} 
              setClientPickerSearch={clientSearch => setClientPickerSearch(clientSearch)} 
              query={this.props.query} 
            />
          </div>
        </div>

        <div style={{zIndex: 20, top: 0, position: "sticky", backgroundColor: "white", width: "100%"}}>
          <Tabs 
            activeKey={this.props.query.tab} 
            id="trip-tabs"
            onSelect={tab => setTab(tab)}
            style={{maxWidth: "100%", display: "inline-block", backgroundColor: "white"}}
          >
            {
              ["nuevos", "propuesta", "negociando", "contrato", "aprobados", "cerrados", "perdidos", "otros"] 
                .map(tab => (
                  <Tab 
                    key={tab}
                    eventKey={tab}
                    title={
                      tabsWithCount.has(tab)
                        ? `${getTabLabel(tab)} (${this.props.tabCounts[tab] || "0"})`
                        : getTabLabel(tab)
                    } 
                  />
                ))
            }
          </Tabs>
          <div style={{float: "right"}}>
            
            <Button glyph="plus" onClick={() => this.create()} style={buttonStyle}>
              {getText("Crear viaje")}
            </Button>
            <TripsReportButton />
          </div>
        </div>

        <Table 
          username={this.props.username}
          activeUserNames={this.props.activeUserNames}
          trips={this.props.filteredTrips}
          Routes={this.props.Routes}
          Activities={this.props.Activities}
          Cities={this.props.Cities}
          tab={this.props.query.tab}
          tags={this.props.tags}
          Trips={this.props.trips}
          query={this.props.query}
          updateStatus={(id, status) => this.props.updateStatus(id, status)} 
          updateTags={(id, tags) => this.props.updateTags(id, tags)}          
          openModal={(id, modal) => this.setState({editingTrip: id, modal})}
          onEdit={id => editTrip(id)}
          onDelete={id => this.remove(id)}
          onSort={k => this.handleSort(k)} 
          sortColumn={this.props.query.sortColumn}
          sortDirection={this.props.query.sortDirection}
          getPendingTasksCount={id => this.props.getTripPendingTasks(id).length}
          onTagClick={tagId => onFilterTag(tagId)}
        />
        
        <PlanTriggerModal />
        {/* EN DUDA <PlanStopModal /> */}
        
        {
          this.state.modal == "tags" && (
            <ModalTagsEditor
              tagType="trips"
              onClose={() => this.setState({modal: null})}
            />
          )
        }
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  const queryGetter = selectors.getFromQuery(state, props)
  
  const p = { 
    // trips: !state.trips ? {} : pickBy(state.trips, t => !t.deleted) 
    Routes: selectors.getAllRoutes(state, props),
    Activities: selectors.getAllActivities(state, props),
    Cities: selectors.getAllCities(state, props),
    ready: selectors.getReadyState(state, props),
    activeUserNames:selectors.getActiveUsernames(state, props), 
    username: state.loginData.username,
    trips: selectors.getTrips(state, props),

    tags: getTripTags(state, props),
    
    query: {
      search:        queryGetter("search")        || "",
      sortDirection: queryGetter("sortDirection") || "ASC",
      sortColumn:    queryGetter("sortColumn")    || "urgency",
      modal:         queryGetter("modal")         || false,
      clientSearch:  queryGetter("clientSearch")  || "",
      tab:           queryGetter("tab")           || "nuevos",
      tag:           queryGetter("tag")           || "all",
      view:          queryGetter("view")          || "table2",
      
      mine:          queryGetter("mine") == "on",
    },
    
    getTripPendingTasks: selectors.makeGetTripPendingTasks(state, props), 
  }

  const p2 = {
    filteredTrips: selectors.getFilteredTripsList(state, p), 
    tabCounts: selectors.getFilteredTripCountPerTab(state, p)
  } 
  return {...p, ...p2}
}

const mapDispatchToProps = (dispatch, props) => ({
  //createTrip: (initials, cb) => dispatch(createTrip(initials, cb)), 
  update: () => dispatch(fetchTrips()), 
  remove: (id) => dispatch(removeTrip(id)), 

  updateTags: (id, tags) => dispatch(updateTrip(id, {tags})),
  updateStatus: (id, status) => dispatch(updateTrip(id, { status })), 
  createTrip: (encargado, cb) => dispatch(createTrip({encargado}, cb))
})


export default connect(mapStateToProps, mapDispatchToProps)(TripsPage)
